/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_OnlyInputs */

const en_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New only`)
};

const de_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur neue`)
};

const fr_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveaux uniquement`)
};

const es_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo nuevos`)
};

const it_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo nuovi`)
};

const nl_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen nieuw`)
};

const pl_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko nowe`)
};

const fi_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain uudet`)
};

const da_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun nye`)
};

const sv_jobs_new_only = /** @type {(inputs: Jobs_New_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bara nya`)
};

/**
* | output |
* | --- |
* | "New only" |
*
* @param {Jobs_New_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_new_only = /** @type {((inputs?: Jobs_New_OnlyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_OnlyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_new_only(inputs)
	if (locale === "fr") return fr_jobs_new_only(inputs)
	if (locale === "es") return es_jobs_new_only(inputs)
	if (locale === "it") return it_jobs_new_only(inputs)
	if (locale === "nl") return nl_jobs_new_only(inputs)
	if (locale === "pl") return pl_jobs_new_only(inputs)
	if (locale === "fi") return fi_jobs_new_only(inputs)
	if (locale === "da") return da_jobs_new_only(inputs)
	if (locale === "sv") return sv_jobs_new_only(inputs)
	return en_jobs_new_only(inputs)
});